/**
 * @fileoverview TradingView configuration and symbol mappings.
 * @module external/tradingview/config
 */

/**
 * Theme configuration matching Gothic Terminal design.
 */
export const TV_THEME = {
  theme: 'dark',
  toolbar_bg: '#0e1317',           // --tg-abyss-black
  hide_top_toolbar: false,
  hide_side_toolbar: false,
  allow_symbol_change: true,
  save_image: false,
  container_id: '',                 // Set per instance
  autosize: true,
  locale: 'en',
};

/**
 * Maps CAP signals to relevant TradingView symbols.
 * @type {Object.<string, import('./types.js').SymbolMapping>}
 */
export const SIGNAL_TO_SYMBOL = {
  // Liquidity signals
  'NET_LIQUIDITY': {
    capSignal: 'NET_LIQUIDITY',
    tvSymbol: 'FRED:WALCL',
    name: 'Fed Balance Sheet',
    description: 'Total assets held by Federal Reserve'
  },
  'TGA_BALANCE': {
    capSignal: 'TGA_BALANCE',
    tvSymbol: 'FRED:WTREGEN',
    name: 'Treasury General Account',
    description: 'US Treasury cash balance at the Fed'
  },
  
  // Volatility signals
  'VIX': {
    capSignal: 'VIX',
    tvSymbol: 'TVC:VIX',
    name: 'VIX Index',
    description: 'S&P 500 implied volatility'
  },
  'MOVE_INDEX': {
    capSignal: 'MOVE_INDEX',
    tvSymbol: 'TVC:MOVE',
    name: 'MOVE Index',
    description: 'Treasury bond implied volatility'
  },
  
  // Rates signals
  'YIELD_CURVE_2S10S': {
    capSignal: 'YIELD_CURVE_2S10S',
    tvSymbol: 'FRED:T10Y2Y',
    name: '2s10s Spread',
    description: '10Y minus 2Y Treasury yield'
  },
  'US10Y': {
    capSignal: 'US10Y',
    tvSymbol: 'TVC:US10Y',
    name: '10-Year Treasury',
    description: 'US 10-year Treasury yield'
  },
  
  // FX signals
  'DXY': {
    capSignal: 'DXY',
    tvSymbol: 'TVC:DXY',
    name: 'Dollar Index',
    description: 'US Dollar Index'
  },
  
  // Credit signals
  'HY_SPREAD': {
    capSignal: 'HY_SPREAD',
    tvSymbol: 'FRED:BAMLH0A0HYM2',
    name: 'High Yield Spread',
    description: 'ICE BofA US High Yield OAS'
  },
  
  // Equity benchmarks (for context)
  'SPX': {
    capSignal: 'SPX',
    tvSymbol: 'FOREXCOM:SPXUSD',
    name: 'S&P 500',
    description: 'S&P 500 Index'
  },
};

/**
 * Curated symbol categories for the picker.
 */
export const SYMBOL_CATEGORIES = {
  'Liquidity': ['NET_LIQUIDITY', 'TGA_BALANCE'],
  'Volatility': ['VIX', 'MOVE_INDEX'],
  'Rates': ['YIELD_CURVE_2S10S', 'US10Y'],
  'FX': ['DXY'],
  'Credit': ['HY_SPREAD'],
  'Equities': ['SPX'],
};

/**
 * Default symbol to show on page load.
 */
export const DEFAULT_SYMBOL = 'VIX';
